import { z } from 'zod'

const DepartmentSchema = z.object({
	name: z.string(),
	basePrice: z.number(),
	baseDebtPerSecond: z.number(),
	description: z.string(),
	sublime: z.boolean().optional(),
	priceMultiplier: z.number().optional()
})

type Department = z.infer<typeof DepartmentSchema>

const isDepartment = (obj: unknown): obj is Department =>
	DepartmentSchema.safeParse(obj).success

export { type Department, isDepartment, DepartmentSchema }
